class WillowChatManager {
  apiKey: string = 'P94B4XX-E6J4RRQ-KYJFXW6-40KYEAE'

  requestToLogin (userId: string | number): Promise<any> {
    return fetch(`https://willow-chat.dev.codeblue.ventures/api/v1/auth/login`, {
      method: 'POST',
      headers: {
        'x-api-key': this.apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ originalId: userId.toString() })
    }).then((res: any) => res.json()).then((data: { token?: string, status?: number, statusCode?: number }) => {
      if (!data.token) {
        throw new Error('Can not login willow')
      }
      this.loginWillowChatUI(data.token as string)
    })
  }

  loginWillowChatUI (token: string) {
    const event = new CustomEvent('willow-chat-login', {
      detail: token
    })
    window.dispatchEvent(event)
  }

  logout () {
    const event = new CustomEvent('willow-chat-logout')
    window.dispatchEvent(event)
  }

  createAccount (data: {
    userId: string | number,
    firstName: string,
    lastName: string,
    email: string
  }): Promise<any> {
    return fetch('https://willow-chat.dev.codeblue.ventures/api/v1/users', {
      method: 'POST',
      headers: {
        'x-api-key': this.apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        originalId: data.userId.toString(),
        avatar: null
      })
    }).then((res: any) => res.json())
  }
}

export default new WillowChatManager()
